import { render, staticRenderFns } from "./answerDetail.vue?vue&type=template&id=411871a1&scoped=true&"
import script from "./answerDetail.vue?vue&type=script&lang=ts&"
export * from "./answerDetail.vue?vue&type=script&lang=ts&"
import style0 from "./answerDetail.vue?vue&type=style&index=0&id=411871a1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "411871a1",
  null
  
)

export default component.exports